import { getApi, postApi } from "../utils/apiHelper";

export const getSoftwarePortfolios = () => {
    return getApi('/portfolio/software/portfolio');
}

export const getDesignPortfolios = () => {
    return getApi('/portfolio/design/portfolio');
}

export const sendContactRequest = (data) => {
    const header = {
        'Content-Type': 'multipart/form-data',
    }
    return postApi('/portfolio/contact-request/', data, header);
}